import React from "react";
import { Button, Card, CardHeader, CardTitle, CardBody, CardFooter } from "reactstrap";
import ICustomer from "../../../types/ICustomer";
import { Link } from "react-router-dom";
import profileImg from "../../../assets/img/profile/placeholder.svg";
import { Star, Share2, Calendar,  } from "react-feather";
interface ICustomerCardProps {
    customer: ICustomer,
    hasAddNewFunctionality: boolean,
    onShareClick: (cust:ICustomer)=>void,
    onCalendarClick: (cust:ICustomer)=> void,
    onSelectCustomer: (cust:ICustomer)=> void
}
export const  CustomerCard = (props:ICustomerCardProps) => {
    const cust = props.customer;
    return (<Card key={cust.uid} style={{borderRadius: "0.5rem"}}>
    <Link 
      to={`/customer/view/${cust.uid}`}
      className={props.hasAddNewFunctionality ? "" : "disabledCursor"}>
      <CardHeader 
        className="d-flex flex-column justify-content-center align-items-center">
          <div style={{ height: "120px", width: "120px", overflow: "hidden", borderRadius: "50%", border: "1px solid #cacaca" }}>
            <img src={cust.account.image ? cust.account.image : profileImg } alt="profile" style={{ objectFit: "contain", objectPosition: "center", height: "100%", width: "100%" }} />
          </div>
        <CardTitle style={{color: "#333"}} className="mt-2"><b>{cust.account.firstName}&nbsp;{cust.account.lastName}</b></CardTitle>
        <p style={{color: "#333"}} className="mb-0">{cust.account.jobTitle},&nbsp;{cust.account.departmentName}</p>
      </CardHeader>
    </Link>
    <CardBody style={{padding: "1.5rem 1.5rem 1rem 1.5rem"}}>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <Star fill="#FFDF00" color="#FFDF00" size={18} />
          <span style={{ color: "#7367f0", fontSize: "12px" }}> 4.6 </span>
        </div>
        <p style={{ color: "#7367f0", fontSize: "12px" }} className="mb-0"><i>Last Activity:</i> &nbsp;
          {
            cust.lastActivity
              ? <span><i>{cust.lastActivity}</i></span>
              : <span><i>3 days ago</i></span>
          }
        </p>
      </div>
    </CardBody>
    <CardFooter style={{backgroundColor: "#fff"}}>
    {
        props.hasAddNewFunctionality
          ? <div className="d-flex justify-content-around align-items-center flex-wrap">
              <Share2 
                className="actionIcon"
                onClick={() => props.onShareClick(cust)}
                color="#7367f0"
                size={20} 
                strokeWidth={2}  
                />

              <Calendar 
                className="actionIcon"
                onClick={() => props.onCalendarClick(cust)}
                color="#7367f0"
                size={20} 
                strokeWidth={2} />
            </div>
          : <Button 
              onClick={() => props.onSelectCustomer(cust) }
              className="btn block" 
              color="primary" >
              Select
            </Button>
    }
    </CardFooter>
  </Card>)
}